// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.line {
  display: block;
  min-height: 120px;
  position: relative;
}

a {
  text-decoration: none;
  color: inherit;
}

.deleteButton {
  background-color: white;
  color: red;
  position: absolute;
  z-index: 10;
  top: 8px;
  right: 8px;
}

.line mat-card-content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  text-align: center;
}

.line app-yearly-yield-list {
  margin-top: 0.25rem;
  width: 100%;
  max-width: 240px;
}
`, "",{"version":3,"sources":["webpack://./src/app/field/line/line.component.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB","sourcesContent":[".line {\n  display: block;\n  min-height: 120px;\n  position: relative;\n}\n\na {\n  text-decoration: none;\n  color: inherit;\n}\n\n.deleteButton {\n  background-color: white;\n  color: red;\n  position: absolute;\n  z-index: 10;\n  top: 8px;\n  right: 8px;\n}\n\n.line mat-card-content {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n  align-items: center;\n  text-align: center;\n}\n\n.line app-yearly-yield-list {\n  margin-top: 0.25rem;\n  width: 100%;\n  max-width: 240px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
